export const API_ENDPOINT = 'https://copywizard.appspot.com/api';
